import type { ReactNode } from 'react'
import { AppHeader } from '~/components/layout/app-header'
import { Footer } from '~/components/layout/footer'

export function AppShell({ children }: { children: ReactNode }) {
    return (
        <div className='flex h-dvh min-h-0 flex-col overflow-hidden'>
            <a
                href='#main-content'
                className='bg-card text-primary focus:ring-ring sr-only z-[60] rounded-sm px-4 py-2 text-sm font-bold focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:ring-2 focus:outline-none'>
                본문 바로가기
            </a>
            <AppHeader />
            <main id='main-content' className='min-h-0 flex-1 overflow-hidden'>
                {children}
            </main>
            <Footer />
        </div>
    )
}
